export class Pagination {
   page: number;
   per_page: number;
   totalResults: number;
   totalPages: number;
   showingResults: number;
}